import { Component, OnInit, Inject } from '@angular/core';
import {MatIcon, MatDialog, MatTableDataSource, MatSnackBar, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import {COPQMDR} from '../../../models/copq__mdr';
import {TranslateService} from '@ngx-translate/core';
import {PriceObservable} from '../../../services/price.service';
import {MdrService} from '../../../providers/mdr.service';
import {MdrObservable} from '../../../services/mdr.service';
import {UOCObservable} from '../../../services/uoc.service';
import {ActivatedRoute} from '@angular/router';
import {MDR} from '../../../models/mdr';
import {Transport} from '../../../models/transport';
import {Copq} from '../../../models/copq';
import {CostAvoidance} from '../../../models/costAvoidance';
import {UOC} from '../../../models/uoc';
import {UOCMDR} from '../../../models/uoc__mdr';
import {CostAvoidanceMDR} from '../../../models/costAvoidance__mdr';
import {Price} from '../logistic-order.component';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { ExcelService } from '../../../misc/export-xlsx/export-xlsx';
// import * as XLSX from 'xlsx';

@Component({
  selector: 'app-tax',
  templateUrl: './tax.component.html',
  styleUrls: ['./tax.component.scss']
})
export class TaxComponent implements OnInit {
  statusContainer = false;
  mdr: MDR = new MDR;
  role: any;
  currentUser: any;
  sumCOPQ = 0;
  sumAvoid = 0;
  sumUOC = 0;
  sumTotal = 0;
  COPQs: COPQMDR[] = [];
  costAvoidances: CostAvoidanceMDR[] = [];
  UOCs: UOCMDR[] = [];
  uoc: UOC[] = [];
  copq: UOC[] = [];
  price: any;
  user: any;
  nfePrice: number;
  ov: any = [];

  update = true;
  payment = {
    'tooltips': {
            'green': 'Pagamento Realizado',
            'yellow': 'Pagamento Parcial Realizado',
            'red': 'Aguardando Pagamento',
            'undefined': '',
    },
    'icons' : {
            'green':  'fa-check',
            'yellow':    'fa-exclamation-triangle',
            'red':    'fa-exclamation-triangle',
            'undefined': '',
    },
    'classes' : {
            'green':  'icon-green',
            'yellow': 'icon-yellow',
            'red':    'icon-red',
            'undefined': '',
    }
  };
  payField = {
    'color': 'undefined',
    'ov': []
  };


  constructor(public translate: TranslateService,
              public snackBar: MatSnackBar,
              public priceObservable: PriceObservable,
              public mdrService: MdrService,
              public mdrObservable: MdrObservable,
              public uocObservable: UOCObservable,
              public aRoute: ActivatedRoute,
              public excel: ExcelService,
              private dpipe: DatePipe,
              private cpipe: CurrencyPipe,
              public dialog: MatDialog) {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.role = this.currentUser.user.role;
    this.user = this.currentUser.user.id;
  }

  ngOnInit() {
    // pega price
    this.priceObservable.currentPrice.subscribe((price) => {
      this.price = price;
    });
    // quando a MDR mudar
    this.mdrObservable.currentMDR.subscribe(mdr => {
      this.mdr = mdr;
      this.sumTotal = mdr.valorem + mdr.frete + mdr.additional;
      // pega os CoPQs da MDR
      this.mdrService.getCoPQ(this.mdr).subscribe((data) => {
        this.sumCOPQ = 0;
        data.forEach((elem) => {
          elem.value = Number(elem.value) / 100;
          this.sumCOPQ += elem.value;
          elem.value = elem.value.toFixed(2);
        });
        // this.sumCOPQ = this.sumCOPQ / 100;
        this.COPQs = data;
      });
      // pega os CostAvoidances da MDR
      this.mdrService.getCostAvoidance(this.mdr).subscribe((data) => {
        this.sumAvoid = 0;
        data.forEach((elem) => {
          this.sumAvoid += Number(elem.value);
        });
        this.costAvoidances = data;
      });
      // pega a lista de UOCs possíveis
      this.mdrService.getListUOC().subscribe((data) => {
        this.uoc = data;
      });
      // pega a lista de CoPQs possíveis
      this.mdrService.getListCoPQ().subscribe( (data) => {
        this.copq = data;
      });
      // quando os UOCs mudarem
      this.mdrService.getUOC(this.mdr).subscribe((data) => {
        this.sumUOC = 0;
        data.forEach((elem) => {
          elem.value = Number(elem.value) / 100;
          this.sumUOC += elem.value;
          elem.value = Number(elem.value.toFixed(2));
        });
        this.sumUOC /= 100;
        this.UOCs = data;
        // pega os Payments
        this.mdrService.getStatusPayment(this.mdr.id).subscribe( (payments) => {
          let frete_count = 0;
          let frete_paid = 0;
          // itera sobre os pagamentos
          for (let i = 0 ; i < payments.length ; i++ ) {
            if (payments[i].origem === 'FRETE') {
              frete_count = frete_count + 1;
              if (payments[i].status === 'PAID') {
                frete_paid = frete_paid + 1;
              }
            } else { // pra origem='UOC'
              const uoc = this.UOCs.find((u) => (u.id === parseInt(payments[i].origemId, 10)));
              if (!uoc) {
                // pagamento nao está presente na lista de pagamentos
              } else if (payments[i].status === 'PAID') {
                uoc['color'] = 'green';
              } else if (payments[i].status === 'READY_TO_PAY') {
                uoc['color'] = 'red';
              } else {
                uoc['color'] = 'undefined';
              }
            }
          }
          if ( frete_count === frete_paid ) {
            this.payField.color = 'green';
          } else if (frete_paid === 0) {
            this.payField.color = 'red';
          } else {
            this.payField.color = 'yellow';
          }
        });
      });
    });

  }

  removeUOC(uoc) {
    const dialogRef = this.dialog.open(ConfirmDeleteDialogComponent, {
      width: '600px',
      data: {
        text: '',
      }
    });
    dialogRef.afterClosed().subscribe( (response) => {
      if (response[0] === true) {
        this.mdrService.removeOccurrence(uoc).subscribe((elem) => {
          this.mdrService.getUOC(this.mdr).subscribe((data) => {
            this.snackBar.open('Custo deletado corretamente', 'Ok', {
              duration: 4000,
            });
            this.sumUOC = 0;
            data.forEach((item) => {
              item.value = Number(item.value) / 100;
              this.sumUOC += item.value;
              item.value = item.value.toFixed(2);
            });
            this.sumUOC /= 100;
            this.UOCs = data;
          });
        });
      }
    });
  }

  removeCOPQ(copq: COPQMDR) {
   // console.log(copq);
    const dialogRef = this.dialog.open(ConfirmDeleteDialogComponent, {
      width: '600px',
      data: {
        text: '',
      }
    });
    dialogRef.afterClosed().subscribe( (response) => {
      if (response[0] === true) {
        this.mdrService.removeOccurrenceCOPQ(copq).subscribe((elem) => {
          this.mdrService.getCoPQ(this.mdr).subscribe((data) => {
            this.snackBar.open('Custo deletado corretamente', 'Ok', {
              duration: 4000,
            });
            this.sumCOPQ = 0;
            data.forEach((item) => {
              item.value = Number(item.value) / 100;
              this.sumCOPQ += item.value;
              item.value = item.value.toFixed(2);
            });
            this.sumCOPQ /= 100;
            this.COPQs = data;
          });
        });
      }
    });
  }

  sanitizeInputMdr(field: string, value: any, tag: any) {
    let input = value.srcElement.value;
    this.update = false;
    input = input.replace('R$', '');
    input = input.replace(/ /g, '');
    input = input.replace(/\./g, '');
    input = input.replace(',', '.');
    input = input.replace(/[^\d.]/g, '');
    this.mdr[field] = input;
    this.update = true;
  }

  sanitizeInputPrice(field: string, value: any, tag: any) {
    let input = value.srcElement.value;
    this.update = false;
    input = input.replace('R$', '');
    input = input.replace(' ', '');
    input = input.replace('.', '');
    input = input.replace(',', '.');
    input = input.replace(/[^\d.]/g, '');
    this.price[field] = input;
    this.update = true;
  }

  amountCOPQ() {
    this.sumCOPQ = 0;
    this.COPQs.forEach((elem) => {
      this.sumCOPQ += Number(elem.value);
    });
    return (this.sumCOPQ);
  }

  amountCA() {
    this.sumAvoid = 0;
    this.costAvoidances.forEach((elem) => {
      this.sumAvoid += Number(elem.value);
    });
    return this.sumAvoid;
  }

  saveConveyor() {
    this.mdrService.update(this.mdr, this.user).subscribe((response) => {
      // console.log(response);
    });
  }

  savePrice() {
   // console.log(this.price);
    this.mdrService.savePrice(this.price, this.mdr).subscribe( (data) => {
     // console.log('teste');
    });
  }

  getTotal() {
    return this.price.total;
  }

  saveUOC() {

  }

  saveCOPQ() {
    this.COPQs.forEach((copq) => {
      this.mdrService.createCoPQ(copq).subscribe((response) => {
        // console.log(response);
        this.mdrService.getCoPQ(this.mdr).subscribe((data) => {
          this.sumCOPQ = 0;
          data.forEach((elem) => {
            this.sumCOPQ += Number(elem.value);
          });
          this.COPQs = data;
        });
      });
    });
  }

  getAllPriceWithKm() {
    this.mdrService.getAllPriceWithKm(this.mdr).subscribe( (data) => {
      this.price = data;
    });
  }

  saveCA() {
    this.costAvoidances.forEach((costAv) => {
      this.mdrService.createCostAvoidance(costAv).subscribe((response) => {
        // console.log(response);
        this.mdrService.getCostAvoidance(this.mdr).subscribe((data) => {
          this.sumAvoid = 0;
          data.forEach((elem) => {
            this.sumAvoid += Number(elem.value);
          });
          this.costAvoidances = data;
        });
      });
    });
  }
  amountUOC() {
    this.sumUOC = 0;
    this.UOCs.forEach( (elem) => {
      this.sumUOC += Number(elem.value) *  Number(elem['multiplicator']);
    });
    return this.sumUOC;
  }
  amountTotal() {
    this.sumTotal = Number(this.mdr.valorem) + Number(this.mdr.valorem) + Number(this.mdr.additional);
    return this.sumTotal;
  }
  addCOPQ() {
    this.COPQs.push(new COPQMDR);
    this.COPQs[this.COPQs.length - 1].idMDR = this.mdr.id;
  }
  addCA() {
    this.costAvoidances.push(new CostAvoidanceMDR);
    this.costAvoidances[this.costAvoidances.length - 1].idMDR = this.mdr.id;

  }
  toggleClass() {
    if (this.statusContainer === true) {
      this.statusContainer = false;
    } else {
      this.statusContainer = true;
    }
  }

  download() {
    const json = [];
    json.push({
      0: 'MDR ID',
      1: 'Veiculo',
      2: 'Data de coleta',
      3: 'Total NF subida',
      4: 'KM',
      5: 'Total',
      6: 'Tipo',
      7: 'Obs'
    });

    json.push({
      0: this.mdr.pickupID,
      1: this.mdr.vehicle,
      2: this.dpipe.transform(this.mdr.pickupDate, 'dd/MM/yyyy hh:mm'),
      3: this.cpipe.transform(this.nfePrice, 'BRL'),
      4: this.mdr.totalKM,
      5: this.cpipe.transform(this.price.total, 'BRL'),
      6: 'Frete',
      7: ''
    });

    for (const u of this.UOCs) {
      json.push({
        0: this.mdr.pickupID,
        1: this.mdr.vehicle,
        2: this.dpipe.transform(this.mdr.pickupDate, 'dd/MM/yyyy hh:mm'),
        3: this.cpipe.transform(this.nfePrice, 'BRL'),
        4: this.mdr.totalKM,
        5: this.cpipe.transform(u.value, 'BRL'),
        6: 'UOC',
        7: u.uoc
      });
    }

    // const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json, {
    //   skipHeader: true
    // });
    // const workbook: XLSX.WorkBook = { Sheets: { 'taxes': worksheet }, SheetNames: ['taxes'] };
    // const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    // this.excel.saveAsExcelFile(excelBuffer, 'taxes');
  }
}

@Component({
  selector: 'app-confirm-delete-dialog',
  templateUrl: 'confirm-delete-dialog.html',
  styleUrls: ['./../logistic-order.component.scss']
})
export class ConfirmDeleteDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmDeleteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data, public translate: TranslateService) {
    // console.log(translate);
  }

  ngOnInit() {
  }
}
